import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useRef, useEffect } from 'react';
import { uniqueId } from '@paypalcorp/pp-react-utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Animator = function (_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? uniqueId('animatee#') : _ref$id,
      _ref$shouldHide = _ref.shouldHide,
      shouldHide = _ref$shouldHide === void 0 ? false : _ref$shouldHide,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      _ref$onCloseComplete = _ref.onCloseComplete,
      onCloseComplete = _ref$onCloseComplete === void 0 ? onClose : _ref$onCloseComplete,
      _ref$phaseProps = _ref.phaseProps,
      phaseProps = _ref$phaseProps === void 0 ? {
    initial: {
      isHidden: true
    },
    showing: {
      isHidden: false
    },
    hiding: {
      isHidden: true
    }
  } : _ref$phaseProps,
      children = _ref.children;

  var _useState = useState('initial'),
      _useState2 = _slicedToArray(_useState, 2),
      currentPhase = _useState2[0],
      setCurrentPhase = _useState2[1];

  var closeEvent = useRef({
    event: null,
    closeMethod: ''
  });
  var animatee = useRef(id);
  useEffect(function () {
    // istanbul ignore next
    if (process.env.NODE_ENV !== 'production') {
      if (onClose) {
        // eslint-disable-next-line no-console
        console.warn('onClose() has been renamed onCloseComplete(), please update your code');
      }
    }
  });
  useEffect(function () {
    var timer;

    if (!shouldHide && currentPhase === 'initial') {
      // A brief timeout is needed to let the animation begin.
      // Otherwise, react "optimizes" the state transitions
      // --love, BCC
      // istanbul ignorenext
      timer = setTimeout(function () {
        return setCurrentPhase('showing');
      }, 10);
    }

    if (shouldHide && currentPhase !== 'initial') {
      closeEvent.current.closeMethod = 'caller';
      setCurrentPhase('hiding');
    }

    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [shouldHide]);

  var onAnimationEnd = function (evt) {
    /* istanbul ignore else */
    if (evt.target.dataset.animatee === animatee.current) {
      if (currentPhase === 'hiding') {
        // If we're done hiding, tell the app that it's safe to remove us from the DOM
        // istanbul ignore next
        var _ref2 = closeEvent.current || {},
            _event = _ref2.event,
            closeMethod = _ref2.closeMethod; // istanbul ignore next


        if (typeof onCloseComplete === 'function') {
          onCloseComplete(_event, closeMethod);
        }

        setCurrentPhase('initial');
      } else if (typeof onOpen === 'function') {
        onOpen(evt); // Let app know entrance is complete and we're ready for action
      }

      evt.stopPropagation();
      evt.nativeEvent.stopImmediatePropagation();
    }
  };

  if (shouldHide && currentPhase === 'initial') {
    return null;
  }

  var childProps = _objectSpread({
    requestClose: function requestClose(evt, closedBy) {
      closeEvent.current.event = evt;
      closeEvent.current.closeMethod = closedBy;
      setCurrentPhase('hiding');
    },
    'data-animatee': animatee.current
  }, phaseProps[currentPhase]);

  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "animator",
    onTransitionEnd: onAnimationEnd,
    onAnimationEnd: onAnimationEnd
  }, children(childProps));
};

export { Animator };
